export async function firebase_getJSONWebInfo(firebase_db){
  console.log("🚀 ~ file: Firebase.js:3 ~ firebase_getJSONWebInfo ~ firebase_getJSONWebInfo", firebase_getJSONWebInfo)
  const data = {};
  const doc = await firebase_db
    .collection('web_info')
    .doc('SERVER')
    .get()
    .catch((e) => console.error(e))

  if (doc.exists === false) {
    throw new Error('Firebase Document not found');
  }else{
    
    const promises = doc.data()['arr_notifications'].map(async (ref) => {
      const ref_data = await ref.get();
      return ref_data.data();
    });

    const modifiedData = { ...doc.data() };
    modifiedData['arr_notifications'] = await Promise.all(promises);

    return modifiedData
  }
}
    

/* LOGIN functionalities*/ 
export function firebase_signup(auth, email, password) {
  return auth.createUserWithEmailAndPassword(email, password);
}

export function firebase_login(auth, email, password) {
  return auth.signInWithEmailAndPassword(email, password);
}

export function firebase_login_google_provider(auth, googleProvider) {
  console.log("🚀 ~ file: FirebaseAuth.js:10 ~ firebase_login_google_provider ~ firebase_login_google_provider", firebase_login_google_provider);
  auth
    .signInWithPopup(googleProvider)
    .then((result) => {
      var credential = result.credential;
      var token = credential.accessToken;
      var user = result.user;
    })
    .catch((e) => {
      var errorCode = e.code;
      var errorMessage = e.message;
      var email = e.email;
      var credential = e.credential;
    });
}

export function firebase_guestLogin(auth) {
  /* return auth.signInWithEmailAndPassword(pGuest.email, pGuest.passwd) */
  return auth.signInAnonymously();
}

export function firebase_logout(auth) {
  auth
    .signOut()
    .then(() => {
      // Sign-out successful.
      console.log('SIGN OUT')
      return true;
    })
    .catch((e) => {
      // An error happened.
      console.error('ERROR SIGN OUT')
      return false;
    });
}

export function firebase_resetPassword(auth, email) {
  return auth.sendPasswordResetEmail(email);
}

